import React from 'react';
import styled from 'styled-components';
import PageHeroSection from '../components/hero-section/PageHeroSection';
import IntelliCubixColoredImage from '../assets/general/intellicubix-colored.png';
import SoftwareDevelopmentImage from '../assets/services/software.webp';
import WebMobileSolutionsImage from '../assets/services/app-development.webp';
import DataAnalyticsImage from '../assets/services/data-ml.webp';
import Button from '../components/Button';

const MainContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
`;

const PageIntro = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 50px 20px 10px 20px;
  max-width: 1170px;
  margin: 0 auto;

  p {
    font-size: 22px;
    line-height: 1.3;
    font-weight: 400;
    letter-spacing: 1px;
    text-align: justify;
    margin-bottom: 30px;

    span {
      font-weight: 600;
      color: ${(props) => props.theme.colors.magenta};
    }
  }
`

const IntelliCubixColored = styled.img`
  width: 350px;
  height: 59px;
  margin-bottom: 30px;
`;

const MainSection = styled.main`
  width: 100%;

  p {
    font-size: 22px;
    line-height: 1.3;
    font-weight: 400;
    letter-spacing: 1px;
    text-align: justify;
    margin-bottom: 30px;

    span {
      font-weight: 600;
      color: ${(props) => props.theme.colors.magenta};
    }
  }
`;

const ServiceContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor};
  padding: 20px 0;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    padding: 0;
  }
  `;

const ServiceContent = styled.div`
  width: 100%;
  max-width: 1170px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  gap: 30px;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    flex-direction: column;
  }
`;

const ServiceInfo = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    width: 100%;
  }

  h2 {
    font-size: 26px;
    line-height: 1.3;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: justify;
    color: ${(props) => props.theme.colors.navy};
    margin-bottom: 15px;
  }

  p {
    font-size: 22px;
    line-height: 1.3;
    font-weight: 400;
    letter-spacing: 1px;
    text-align: justify;
    margin-bottom: 30px;

    span {
      font-weight: 600;
      color: ${(props) => props.theme.colors.magenta};
    }
  }
`;

const ServiceImageDesktop = styled.img`
  width: 30%;
  height: 100%;
  object-fit: contain;
  display: block;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    display: none;
  }
`;

const ServiceImageMobile = styled.img`

  display: none;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    width: 100%;
    height: 150px;
    display: block;
  }
`;

const Services = () => {
  return (
    <MainContainer>
      <PageHeroSection
        pageTitle="Services"
      />
      <PageIntro>
        <IntelliCubixColored src={IntelliCubixColoredImage} alt="Intellicubix Colored" />

        <p>At <span>IntelliCubix</span>, we craft transformative digital experiences with a fusion of Machine Learning, bespoke design, and strategic insights. Specializing in data-empowered Software Development, innovative Web & Mobile Solutions, and dynamic Digital Marketing, we're your partners in elevating businesses to new heights.</p>
      </PageIntro>
      <MainSection>
        <ServiceContainer backgroundColor="black">
          <ServiceContent>
            <ServiceImageDesktop src={SoftwareDevelopmentImage} alt="Software Development" />
            <ServiceImageMobile src={SoftwareDevelopmentImage} alt="Software Development" />
            <ServiceInfo>
              <h2>Intelligent Software Development</h2>
              <p>Innovate without limits with <span>IntelliCubix</span>’s smart software solutions. Our data-driven approach ensures your software not only solves today's challenges but also anticipates future trends. Experience seamless, scalable, and sophisticated software that grows with your business.</p>
            </ServiceInfo>
          </ServiceContent>
        </ServiceContainer>

        <ServiceContainer backgroundColor="#050F29">
          <ServiceContent>
            <ServiceImageMobile src={WebMobileSolutionsImage} alt="Web & Mobile Solutions" />
            <ServiceInfo>
              <h2>Web & Mobile Solutions</h2>
              <p>Immerse in a world where your digital dreams turn into reality. <span>IntelliCubix</span> crafts tailor-made web and mobile applications that not only perform flawlessly but also tell your unique story. We blend aesthetics with functionality, creating apps that engage, delight, and deliver results.</p>
            </ServiceInfo>
            <ServiceImageDesktop src={WebMobileSolutionsImage} alt="Web & Mobile Solutions" />
          </ServiceContent>
        </ServiceContainer>

        <ServiceContainer backgroundColor="#080E1A">
          <ServiceContent>
            <ServiceImageDesktop src={DataAnalyticsImage} alt="Data Analytics & Machine Learning" />
            <ServiceImageMobile src={DataAnalyticsImage} alt="Data Analytics & Machine Learning" />
            <ServiceInfo>
              <h2>Data Analytics & Machine Learning</h2>
              <p>Step beyond traditional analytics with <span>IntelliCubix</span>'s advanced data analysis and machine learning solutions. Transform data into actionable insights and predictive power, driving your business forward with confidence. Our custom models are your key to unlocking new opportunities and optimizing performance.</p>
            </ServiceInfo>
          </ServiceContent>
        </ServiceContainer>

      </MainSection>

      <Button text="LET’S CRAFT YOUR SUCCESS STORY TOGETHER" />

    </MainContainer>
  );
};

export default Services;

